import { useEffect, useRef, useState, type ReactNode } from "react";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { setzeRueckfrage } from "../lib/api";

/** Dialog für Änderungen an abgeschlossenen Steuerjahren (User 28.10.2026, „A“). Wird einmal um die App gelegt; api.ts ruft ihn bei 409 auf. */
export function AbschlussRueckfrage({ children }: { children: ReactNode }) {
  const [frage, setFrage] = useState<{ error: string; abgeschlossen: number[] } | null>(null);
  const antwort = useRef<((ja: boolean) => void) | null>(null);
  useEffect(() => {
    setzeRueckfrage((p) => new Promise<boolean>((resolve) => { antwort.current = resolve; setFrage(p); }));
    return () => setzeRueckfrage(null);
  }, []);
  const schliessen = (ja: boolean) => { antwort.current?.(ja); antwort.current = null; setFrage(null); };
  return (
    <>
      {children}
      {frage && (
        <Dialog open onClose={() => schliessen(false)} className="relative z-50">
          <div className="fixed inset-0 bg-black/30" aria-hidden />
          <div className="fixed inset-0 flex items-end md:items-center justify-center p-4">
            <DialogPanel className="w-full max-w-lg rounded-iosLg bg-white p-4 shadow-card text-[14px]">
              <DialogTitle className="text-[17px] font-semibold">Abgeschlossenes Steuerjahr ändern?</DialogTitle>
              <p className="mt-2">{frage.error}</p>
              <p className="mt-2 text-ios-muted">Das festgehaltene Ergebnis bleibt, bis du das Jahr neu abschließt. Auf der Steuer-Seite siehst du danach,
                was sich gegenüber dem Stand beim Steuerberater ändern würde.</p>
              <div className="mt-4 flex justify-end gap-2">
                <button type="button" onClick={() => schliessen(false)} className="px-3 py-1.5 rounded-ios bg-white shadow-card">Abbrechen</button>
                <button type="button" onClick={() => schliessen(true)} className="px-3 py-1.5 rounded-ios bg-ios-blue text-white">Trotzdem speichern</button>
              </div>
            </DialogPanel>
          </div>
        </Dialog>
      )}
    </>
  );
}
